const API_URL = (import.meta.env.VITE_API_URL as string) || '';
const MEDIA_URL = (import.meta.env.VITE_MEDIA_URL as string) || '';
const STORAGE_PREFIX = (import.meta.env.VITE_STORAGE_PREFIX as string) || '';

export { API_URL, MEDIA_URL, STORAGE_PREFIX };
